import React from 'react';
import { Mic, MicOff } from 'lucide-react';

const MuteButton = ({ onClick, isMuted, isSpeaking }) => {
  return (
    <div className="relative group">
      <button
        onClick={onClick}
        className={`
          relative p-4 rounded-2xl transition-all duration-300
          hover:scale-105 active:scale-95 shadow-lg
          ${isMuted
            ? 'bg-gradient-to-br from-red-500/20 to-red-600/20 hover:from-red-500/30 hover:to-red-600/30'
            : 'bg-gradient-to-br from-blue-500/20 to-blue-600/20 hover:from-blue-500/30 hover:to-blue-600/30'
          }
        `}
        title={isMuted ? 'Unmute microphone' : 'Mute microphone'}
      >
        {/* Glass overlay */}
        <div className="absolute inset-0 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/20"></div>

        {/* Icon container */}
        <div className="relative z-10 flex items-center justify-center">
          <div className={`
            p-2 rounded-full transition-all duration-300
            ${isMuted ? 'bg-red-500/20' : 'bg-blue-500/20'}
          `}>
            {isMuted ? (
              <MicOff className="w-6 h-6 text-red-300"/>
            ) : (
              <div className="relative">
                <Mic className="w-6 h-6 text-blue-300"/>
                {/* Speaking animation */}
                {isSpeaking && (
                  <div className="absolute inset-0 rounded-full animate-ping bg-blue-400/30"></div>
                )}
              </div>
            )}
          </div>

          {/* Status text */}
          <span className={`
            ml-3 text-sm font-medium transition-all duration-300 min-w-[60px]
            ${isMuted ? 'text-red-300' : 'text-blue-300'}
          `}>
            {isMuted ? 'MUTED' : 'LIVE'}
          </span>
        </div>

        {/* Status indicator */}
        <div className={`
          absolute top-2 right-2 w-2 h-2 rounded-full transition-all duration-300
          ${isMuted ? 'bg-red-500' : 'bg-green-500 animate-pulse'}
        `}></div>
      </button>

      {/* Tooltip */}
      <div className="absolute -top-14 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300">
        <div className="bg-gray-900/95 backdrop-blur-md text-white text-sm px-4 py-2 rounded-lg shadow-xl border border-white/10">
          {isMuted ? 'Click to unmute' : 'Click to mute'}
        </div>
      </div>
    </div>
  );
};

export default MuteButton;
